/** Toggles document.body from scrolling */
export const bodyScroll = (scroll: boolean): void => {
  if (scroll) {
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
  } else {
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100%'
  }
}
